export default __webpack_public_path__ + "static/media/missions_screenshot.d8652b5f.png";